<template>
  <v-container v-if="DataRol !== null" grid-list-xl>
    <div class="vue-contentido">

      <v-divider></v-divider>

      <v-layout row wrap>
        <v-flex xs12>
          <v-card :elevation="2" :loading="loading" :disabled="loading">
            <v-card-title>Lista de roles</v-card-title>
            <v-card-text active-class="deep-purple accent-4 white--text">
              <v-flex xs12 sm12>
                <v-data-table
                  :headers="headerRol"
                  :items="groles"
                  class="elevation-1"
                  :no-data-text="gnodata"
                  :items-per-page="5"
                >
                  <template v-slot:item.action="{ item }">
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small class="mr-2" v-scroll-to="'#containera'" @click="grideditrol(item)">edit</v-icon>
                        </template>
                        <span>Registrar</span>
                      </v-tooltip>
                    </td>
                  </template>
                </v-data-table>

                <v-divider></v-divider>
              </v-flex>
              <v-card id="containera" ref="containera" v-show="frameRol" color="#EEEEEE">
                <v-card-title>{{EditedRol.nombre}}</v-card-title>
                <v-card-text>
                  <v-flex row wrap>
                    <v-flex sm5 xs12>
                      <v-text-field
                        v-model="EditedRol.nombre"
                        label="Nombre: *"
                        v-validate="'required'"
                        data-vv-name="nombrerol"
                        :error-messages="errors.collect('nombrerol')"
                      ></v-text-field>
                    </v-flex>

                    <v-flex sm5 xs12>
                      <v-select
                        :items="gopcionesdefault"
                        v-model="EditedRol.idopciondefecto"
                        item-text="titulo"
                        item-value="idopcion"
                        label="Opción por defecto *"
                        v-validate="'required'"
                        data-vv-name="opciondefecto"
                        :error-messages="errors.collect('opciondefecto')"
                      ></v-select>
                    </v-flex>
                    <v-flex sm2 xs12>
                      <v-checkbox v-model="EditedRol.activo" label="Activo"></v-checkbox>
                    </v-flex>
                  </v-flex>

                  <v-flex sm12 xs12>
                    <v-treeview
                      dense
                      selectable
                      selection-type="leaf"
                      v-model="selectedOpcion"
                      selected-color="red"
                      :items="items"
                      open-on-click
                    ></v-treeview>
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn class="mx-1" color="blue darken-1" v-on="on" @click="cerrarrollocal">Cancelar</v-btn>
                    </template>
                    <span>Cancelar</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn class="mx-1" color="blue darken-1" v-on="on" @click="guardarrollocal">Guardar</v-btn>
                    </template>
                    <span>Guardar</span>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>

    <v-speed-dial
      fixed
      :top="false"
      :bottom="true"
      :right="true"
      :left="false"
      direction="left"
      :open-on-hover="true"
      transition="scale-transition"
    >
      <template v-slot:activator>
        <v-btn fab color="pink">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small color="green" @click="guardarrollocal">
        <v-icon>save</v-icon>
      </v-btn>
    </v-speed-dial>

    <v-snackbar v-model="snack" :timeout="timeoutsnak" :color="MesaggeInfo.color">
      {{this.MesaggeInfo.codigoRespuesta}}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="functionalert"></v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "adminroles",
  data() {
    return {
      //datos del rol
      selectedOpcion: [],
      TempOpcionesRol: [],

      DataRol: [],
      EditedRol: {
        nombre: "",
        activo: false,
        visible: false,
        idopciondefecto: 0,
        opciondefecto: {
          titulo: "",
          idopcion: 0
        }
      },
      DefaultEditedRol: {
        nombre: "",
        activo: false,
        visible: false,
        idopciondefecto: 0,
        opciondefecto: {
          titulo: "",
          idopcion: 0
        }
      },
      editedRolIndex: -1,
      expanded: [],
      singleExpand: false,
      frameRol: false,
      headerRol: [
        { text: "Nombre", value: "nombre", align: "left" },
        {
          text: "Opcion por Defecto",
          value: "opciondefecto.titulo",
          align: "left"
        },
        { text: "Acciones", value: "action", sortable: false }
      ],


      //datos opciones
      DataOpciones: [],
      items: [
        {
          id: 0,
          name: "",
          children: [{ id: 0, name: "", children: [{ id: 0, name: "" }] }]
        }
      ],

      //datos rolopciones
      DataRolOpciones: [],
      headerRolOpciones: [
        { text: "Nombre", value: "nombre", align: "left" },
        {
          text: "Opcion por Defecto",
          value: "opciondefecto.titulo",
          align: "left"
        },

        { text: "", value: "data-table-expand" }
      ],
      Datacargada: false,

      //elementos del fomrulario
      buttonguardarestado: false,
      buttonfinalizarestado: false,
      loading: false,

      //campos del cuadro de dialog de mensajes
      snack: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      timeoutsnak: 4000,
      buttontext: "cerrar"
    };
  },
  methods: {
    ...mapActions(["get_roles", "Postrol"]),
    ...mapActions(["get_opciondefecto", "get_opciondarbol"]),
    ...mapActions("usuario/", ["get_usuarios"]),
    SaveRol() {
      this.loading = true;
      this.Postrol({
        data: this.DataRol
      });
    },
    FinalizarRol() {},
    grideditrol(item) {
      this.editedRolIndex = this.DataRol.indexOf(item);
      this.EditedRol = Object.assign({}, item);
      this.TempOpcionesRol = [];
      this.selectedOpcion = [];

      this.EditedRol.rolOpcion.forEach(element => {
        this.TempOpcionesRol.push(element.idopcion);
      });
      this.frameRol = true;
      this.selectedOpcion = this.TempOpcionesRol;
    },
    guardarrollocal() {
      this.selectedOpcion.forEach(element => {
        this.DataRolOpciones.push({
          idrol: this.EditedRol.idrol,
          idopcion: element
        });
      });

      if (this.DataRolOpciones.length > 1) {
        this.EditedRol.rolOpcion = [];

        this.gopcionesdefault.forEach(element => {
          if (element.idopcion == this.EditedRol.idopciondefecto) {
            this.EditedRol.opciondefecto.idopcion = element.idopcion;
            this.EditedRol.opciondefecto.titulo = element.titulo;
          }
        });

        Object.assign(this.EditedRol.rolOpcion, this.DataRolOpciones);
        this.DataRolOpciones = [];
      }

      this.EditedRol.modificado = true;
      Object.assign(this.DataRol[this.editedRolIndex], this.EditedRol);
      this.EditedRol = this.DefaultEditedRol;
      this.frameRol = false;
      this.SaveRol();

    },
    cerrarrollocal() {
      this.EditedRol = Object.assign({}, this.DefaultEditedRol);
      this.frameRol = false;
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.buttontext == "cerrar";
        this.snack = false;
        this.timeoutsnak = 4000;
        let ruta = localStorage.pathfrom;
        this.$router.push(ruta);
      }
    }
  },
  created() {
    this.get_usuarios();
    this.get_roles();
    this.get_opciondefecto();
    this.get_opciondarbol();
  },
  computed: {
    ...mapGetters(["groles"]),
    ...mapGetters(["gopcionesdefault", "gopcionesarbol"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("usuario", ["gusuario", "gusuarios"])
  },
  watch: {
    groles: function() {
      this.DataRol = this.groles;
    },
    gopcionesarbol: function() {
      this.DataOpciones = this.gopcionesarbol;
      this.items = [];
      let childitems = [];
      let LastChild = [];
      this.selectedOpcion = [];

      this.DataOpciones.forEach(element => {
        childitems = [];
        element.hijos.forEach(elementijo => {
          LastChild = [];
          elementijo.hijos.forEach(lastHijo => {
            LastChild.push({ id: lastHijo.idopcion, name: lastHijo.titulo });
          });
          childitems.push({
            id: elementijo.idopcion,
            name: elementijo.titulo,
            children: LastChild
          });
        });
        this.items.push({
          id: element.idopcion,
          name: element.titulo,
          children: childitems
        });
      });
    },
    selectedOpcion: function() {
      if (this.TempOpcionesRol.length > 1) {
        this.selectedOpcion = this.TempOpcionesRol;
        this.TempOpcionesRol = [];
      }
    },
    ginformation() {
      if (this.loading) {
        this.MesaggeInfo = this.ginformation;
        this.snack = true;
        //este console por favor dejarlo, es para que el usuario tenga en consola los posibles mensajes por si no alcanza a leerlo
        console.log(this.MesaggeInfo.mensajeRespuesta);
        this.loading = false;
      }
    }
  }
};
</script>